import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.js";
import SectionCompletedExamples from "./Sections/SectionCompletedExamples.js";
import SectionLogin from "./Sections/SectionLogin.js";
import SectionDownload from "./Sections/SectionDownload.js";
import ProductSection from "../LandingPage/Sections/ProductSection.js";

import styles from "assets/jss/material-kit-react/views/components.js";

import Chatbot from "react-chatbot-kit";
import chatbot2 from "../../views/ChatBot/img/chatbot5.gif";

import ActionProvider from "../../views/ChatBot/bot/ActionProvider";
import MessageParser from "../../views/ChatBot/bot/MessageParser";
import config from "../../views/ChatBot/bot/config";

import "./Components.css";

const useStyles = makeStyles(styles);

export default function Components(props) {
  const classes = useStyles();
  const { ...rest } = props;

  function myFunction() {
    var x = document.getElementById("myDIV");
    if (x.style.display === "none") {
      x.style.display = "flex";
    } else {
      x.style.display = "none";
    }
  }

  return (
    <div>
      <Header
        brand="Rachit Mehrotra.io"
        rightLinks={<HeaderLinks />}
        fixed
        color="white"
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Parallax image={require("assets/img/Images/homepage2.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h4 className="zoom">Hi, my name is Rachit Mehrotra</h4>
                <h1 className={classes.title}>
                  Full Stack Developer, Technical Designer & Mentor.
                </h1>
                <h3 className={classes.caption} style={{ color: "#f8f8ff" }}>
                  I build and code things for everyone, and I love what I do.
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classes.container}>
        <div className="App2" id="myDIV">
          <Chatbot
            actionProvider={ActionProvider}
            messageParser={MessageParser}
            config={config}
          />
        </div>
        
          <div className="test">
            <img
              className="logo"
              src={chatbot2}
              alt="Girl in a jacket"
              width="65"
              height="55"
              onClick={myFunction}
            />
          </div>
        
      </div>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <ProductSection />
        <SectionCompletedExamples />
        <SectionLogin />
        <SectionDownload />
      </div>
      <Footer />
    </div>
  );
}
